import { useEffect, useMemo, useState } from 'react';
import { useLegacyChapterCache } from './chapter-cache';
import { DocReaderContext, type DocReaderProps } from './core';

export type { DocReaderViewHandle } from './core';

export function DocReaderProvider({
  children,
  logSettings,
  ...props
}: DocReaderProps) {
  const [logger] = useState(() =>
    logSettings.parentLogger.child(
      { module: 'DocReader' },
      logSettings.logOptions,
    ),
  );

  const { cachedChunks, paragraphCounts } = useLegacyChapterCache(
    props.documentSummary,
  );
  const docReaderContext = useMemo(
    () => ({
      ...props,
      logger,
      cachedChunks,
      paragraphCounts,
    }),
    [cachedChunks, logger, paragraphCounts, props],
  );

  useEffect(() => {
    logger.info(
      {
        audioId: props.documentSummary.id,
        chaptersLength: props.documentSummary.chapters.length,
      },
      'Initialized',
    );
  }, [logger, props]);

  return (
    <DocReaderContext value={docReaderContext}>{children}</DocReaderContext>
  );
}
